import { Button, Typography } from "@mui/material";
import Box from "@mui/material/Box/Box";
import { useNavigate } from "react-router-dom";
import ClientIcon from "../../../../assets/img/client.png";
import PetshopManagerIcon from "../../../../assets/img/petshopManager.png";
import LoginIcon from "@mui/icons-material/Login";
import styles from "./styles";
import Footer from "../../../../components/general/Footer";
import { petSecondaryGreen } from "../../../../styles/colors";
import { useAuth } from "@/context/AuthProvider/useAuth";
import { useTranslation } from "react-i18next";
const PetLandingPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { logout } = useAuth();

  const firstSection = (
    <section style={styles.firstSectionContainer}>
      <Box sx={styles.firstSectionHeader}>
        <Box sx={{ marginLeft: "15px" }}>
          <Typography variant="h5" fontWeight="bold">
              {t("landingPage.pet.headerTitle")}
          </Typography>
        </Box>
        <Box sx={styles.alreadyRegisteredContainer}>
          <Typography sx={styles.alreadyRegisteredLabel}>
              {t("landingPage.common.headers.alreadyAccount")}
          </Typography>

          <Button
            sx={styles.loginButton}
            disableElevation
            variant="outlined"
            onClick={() => {
              logout();
              navigate("/login");
            }}
            color="secondary"
          >
              {t("landingPage.common.headers.login")}
          </Button>
        </Box>
      </Box>
      <Box sx={styles.presentationContainer}>
        <Typography variant="h4" fontWeight="bold">
            {t("landingPage.pet.hero.titlePrefix")}
          <span style={{ color: petSecondaryGreen, marginLeft: "8px" }}>
             {t("landingPage.pet.hero.titleHighlight")}
          </span>
        </Typography>
        <Typography variant="h6" fontWeight="regular">
            {t("landingPage.pet.hero.subtitle")}
        </Typography>

        <Button
          sx={styles.registerButton}
          disableElevation
          variant="contained"
          startIcon={<LoginIcon />}
          onClick={() => navigate("/register")}
          color="secondary"
        >
        {t("landingPage.common.buttons.register")}
        </Button>
      </Box>
    </section>
  );

  const secondSection = (
    <section style={styles.secondSectionContainer}>
      <Box sx={styles.secondSectionHeader}>
        <Typography variant="h5" fontWeight="bold">
            {t("landingPage.pet.roles.sectionTitle")}
        </Typography>
        <Typography>{t("landingPage.common.roles.subtitle")}</Typography>
      </Box>
      <Box sx={styles.roleCardContainer}>
        <Box sx={styles.roleCard}>
          <img
            src={ClientIcon}
            alt="Client icon"
            style={styles.roleCardImage}
          />
          <Typography variant="h6" fontWeight="bold">
              {t("landingPage.common.roles.clientTitle")}
          </Typography>
          <Typography>
              {t("landingPage.pet.roles.clientDesc")}
          </Typography>
        </Box>
        <Box sx={styles.roleCard}>
          <img
            src={PetshopManagerIcon}
            alt="Pet Manager icon"
            style={styles.roleCardImage}
          />
          <Typography variant="h6" fontWeight="bold">
              {t("landingPage.common.roles.commercialTitle")}
          </Typography>
          <Typography>
              {t("landingPage.common.roles.commercialDesc")}
          </Typography>
        </Box>
      </Box>
    </section>
  );

  return (
    <Box width="100%" height="100vh">
      {firstSection}

      <Footer />
    </Box>
  );
};

export default PetLandingPage;
